// Generated by purs version 0.15.15
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Geocoding_Types_StreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Geocoding_Types_StreetAddress.eqStreetAddress);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Coordinates.eqCoordinates);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var NetworkErrorIsSymbol = {
    reflectSymbol: function () {
        return "NetworkError";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var streetAddressIsSymbol = {
    reflectSymbol: function () {
        return "streetAddress";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetAddressIsSymbol)(Restaumatic_Geocoding_Types_StreetAddress.showStreetAddress);
var AddressDoesNotExistOrInaccurateIsSymbol = {
    reflectSymbol: function () {
        return "AddressDoesNotExistOrInaccurate";
    }
};
var coordinatesIsSymbol = {
    reflectSymbol: function () {
        return "coordinates";
    }
};
var RestaurantDoesntDeliverToIsSymbol = {
    reflectSymbol: function () {
        return "RestaurantDoesntDeliverTo";
    }
};
var ChooseRestaurantIsSymbol = {
    reflectSymbol: function () {
        return "ChooseRestaurant";
    }
};
var ChangeRestaurantIsSymbol = {
    reflectSymbol: function () {
        return "ChangeRestaurant";
    }
};
var RestaurantDeliversIsSymbol = {
    reflectSymbol: function () {
        return "RestaurantDelivers";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var decodeSingleConstructorAr = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr();
var decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(streetAddressIsSymbol)(Restaumatic_Geocoding_Types_StreetAddress.unscrambleDecodeStreetAddress)(Unscramble.decodeRecordNil);
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_Types_StreetAddress.encodeStreetAddress));
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons1 = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons2 = /* #__PURE__ */ decodeRecordCons1(Foreign_Generic_Class.decodeRecordNil)(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Geocoding_Types_StreetAddress.decodeStreetAddress))();
var NetworkError = /* #__PURE__ */ (function () {
    function NetworkError() {

    };
    NetworkError.value = new NetworkError();
    return NetworkError;
})();
var AddressDoesNotExistOrInaccurate = /* #__PURE__ */ (function () {
    function AddressDoesNotExistOrInaccurate(value0) {
        this.value0 = value0;
    };
    AddressDoesNotExistOrInaccurate.create = function (value0) {
        return new AddressDoesNotExistOrInaccurate(value0);
    };
    return AddressDoesNotExistOrInaccurate;
})();
var RestaurantDoesntDeliverTo = /* #__PURE__ */ (function () {
    function RestaurantDoesntDeliverTo(value0) {
        this.value0 = value0;
    };
    RestaurantDoesntDeliverTo.create = function (value0) {
        return new RestaurantDoesntDeliverTo(value0);
    };
    return RestaurantDoesntDeliverTo;
})();
var ChooseRestaurant = /* #__PURE__ */ (function () {
    function ChooseRestaurant() {

    };
    ChooseRestaurant.value = new ChooseRestaurant();
    return ChooseRestaurant;
})();
var ChangeRestaurant = /* #__PURE__ */ (function () {
    function ChangeRestaurant() {

    };
    ChangeRestaurant.value = new ChangeRestaurant();
    return ChangeRestaurant;
})();
var RestaurantDelivers = /* #__PURE__ */ (function () {
    function RestaurantDelivers() {

    };
    RestaurantDelivers.value = new RestaurantDelivers();
    return RestaurantDelivers;
})();
var toFillFormTypeFindAddress = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqFindAddressResult = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NetworkError && y instanceof NetworkError) {
                return true;
            };
            if (x instanceof AddressDoesNotExistOrInaccurate && y instanceof AddressDoesNotExistOrInaccurate) {
                return eq(x.value0.streetAddress)(y.value0.streetAddress);
            };
            if (x instanceof RestaurantDoesntDeliverTo && y instanceof RestaurantDoesntDeliverTo) {
                return eq1(x.value0.coordinates)(y.value0.coordinates) && eq(x.value0.streetAddress)(y.value0.streetAddress);
            };
            if (x instanceof ChooseRestaurant && y instanceof ChooseRestaurant) {
                return true;
            };
            if (x instanceof ChangeRestaurant && y instanceof ChangeRestaurant) {
                return true;
            };
            if (x instanceof RestaurantDelivers && y instanceof RestaurantDelivers) {
                return true;
            };
            return false;
        };
    }
};
var genericFindAddressResult = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NetworkError.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new AddressDoesNotExistOrInaccurate(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new RestaurantDoesntDeliverTo(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return ChooseRestaurant.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return ChangeRestaurant.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return RestaurantDelivers.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.FindAddressResult (line 16, column 1 - line 16, column 89): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NetworkError) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof AddressDoesNotExistOrInaccurate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof RestaurantDoesntDeliverTo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof ChooseRestaurant) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof ChangeRestaurant) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof RestaurantDelivers) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))));
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.FindAddressResult (line 16, column 1 - line 16, column 89): " + [ x.constructor.name ]);
    }
};
var showFindAddressResult = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFindAddressResult)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(NetworkErrorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsConsNil)))(AddressDoesNotExistOrInaccurateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(coordinatesIsSymbol)(showRecordFieldsConsNil)(Data_Coordinates.showCoordinates))))(RestaurantDoesntDeliverToIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ChooseRestaurantIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ChangeRestaurantIsSymbol))(/* #__PURE__ */ genericShowConstructor(RestaurantDeliversIsSymbol)))))))
};
var unscrambleDecodeFindAddressResult = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericFindAddressResult)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(NetworkErrorIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(AddressDoesNotExistOrInaccurateIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(decodeRecordCons)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(RestaurantDoesntDeliverToIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(coordinatesIsSymbol)(Data_Coordinates.unscrambleDecodeCoordinates)(decodeRecordCons))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(ChooseRestaurantIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(ChangeRestaurantIsSymbol))(/* #__PURE__ */ genericDecodeSumConstruct1(RestaurantDeliversIsSymbol))))))))(Unscramble_Generic.defaultOptions)
};
var encodeFindAddressResult = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericFindAddressResult)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(NetworkErrorIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(AddressDoesNotExistOrInaccurateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(encodeRecordCons1))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(RestaurantDoesntDeliverToIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(encodeRecordCons1)(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Coordinates.encodeCoordinates))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ChooseRestaurantIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ChangeRestaurantIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(RestaurantDeliversIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))))
};
var decodeFindAddressResult = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericFindAddressResult)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(NetworkErrorIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(AddressDoesNotExistOrInaccurateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(decodeRecordCons2)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(RestaurantDoesntDeliverToIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(decodeRecordCons2)(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Coordinates.decodeCoordinates))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ChooseRestaurantIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ChangeRestaurantIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(RestaurantDeliversIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))))
};
export {
    NetworkError,
    AddressDoesNotExistOrInaccurate,
    RestaurantDoesntDeliverTo,
    ChooseRestaurant,
    ChangeRestaurant,
    RestaurantDelivers,
    genericFindAddressResult,
    eqFindAddressResult,
    showFindAddressResult,
    encodeFindAddressResult,
    decodeFindAddressResult,
    unscrambleDecodeFindAddressResult,
    toFillFormTypeFindAddress
};
